<template>
  <div id="ListAzaFile" dir="rtl">
    <loading v-if="loading"></loading>
    <panel
      v-if="ShowHeader"
      class="no-print"
      Title="دریافت فایل و مدارک"
      Des="از طریق این فرم می‌توانید فایل‌های ارسال شده توسط کاربران را دریافت کنید"
      :IsBtnBack="true"
      ClassCustom="bg-dark-Custom text-right mt-2"
    ></panel>
    <div :class="ShowHeader ? 'row px-3' : ''">
      <div :class="ShowHeader ? 'col-12 col-md-12 mx-md-2 p-md-3' : ''">
        <net-pa-card v-if="ShowHeader" :Compact="true">
          <template slot="content">
            <div class="list-aza-file">
              <p v-if="!ListFile.length" class="list-aza-file__empty">
                فایلی برای نمایش وجود ندارد
              </p>
              <template v-else>
                <div class="list-aza-file__toolbar">
                  <input
                    v-model="cardSearch"
                    type="search"
                    class="form-control list-aza-file__search"
                    placeholder=" جستجو"
                    aria-label="جستجو در فایل‌ها"
                  />
                </div>
                <p
                  v-if="filteredFiles.length === 0"
                  class="list-aza-file__empty"
                >
                  اطلاعاتی یافت نشد
                </p>
                <div v-else class="list-aza-file__list">
                  <article
                    v-for="(item, index) in filteredFiles"
                    :key="(item.wwwtblAttachmentId || 'file') + '-' + index"
                    class="list-aza-file-card"
                  >
                    <div class="list-aza-file-card__preview" aria-hidden="true">
                      <i :class="fileIcon(item.filename)"></i>
                    </div>
                    <div class="list-aza-file-card__body">
                      <div class="list-aza-file-card__header">
                        <strong class="list-aza-file-card__name">{{
                          IsAdmin
                            ? item.fullName || item.filename
                            : item.filename
                        }}</strong>
                      </div>
                      <div class="list-aza-file-card__fields">
                        <div
                          v-if="IsAdmin && item.filename"
                          class="list-aza-file-card__field"
                        >
                          <span>نام فایل</span>
                          <strong>{{ item.filename }}</strong>
                        </div>
                        <div
                          v-if="IsAdmin && item.codemeli"
                          class="list-aza-file-card__field"
                        >
                          <span>کد ملی</span>
                          <strong dir="ltr">{{ item.codemeli }}</strong>
                        </div>
                        <div
                          v-if="IsAdmin && item.perNo"
                          class="list-aza-file-card__field"
                        >
                          <span>شماره پرسنلی</span>
                          <strong dir="ltr">{{ item.perNo }}</strong>
                        </div>
                      </div>
                      <div class="list-aza-file-card__actions">
                        <button
                          type="button"
                          class="list-aza-file-chip list-aza-file-chip--download"
                          @click="Download(item)"
                        >
                          <i class="fas fa-download" aria-hidden="true"></i>
                          دانلود فایل
                        </button>
                        <button
                          v-if="IsAdmin"
                          type="button"
                          class="list-aza-file-chip list-aza-file-chip--hide"
                          @click="Hide(item)"
                        >
                          <i class="fas fa-eye-slash" aria-hidden="true"></i>
                          عدم نمایش
                        </button>
                      </div>
                    </div>
                  </article>
                </div>
                <div
                  v-if="pageCount > 1"
                  class="list-aza-file__pager"
                >
                  <button
                    type="button"
                    class="list-aza-file__pager-btn"
                    :disabled="ActivePage <= 1"
                    @click="prevPage"
                  >
                    قبلی
                  </button>
                  <span class="list-aza-file__pager-info">
                    صفحه {{ ActivePage }} از {{ pageCount }}
                  </span>
                  <button
                    type="button"
                    class="list-aza-file__pager-btn"
                    :disabled="ActivePage >= pageCount"
                    @click="nextPage"
                  >
                    بعدی
                  </button>
                </div>
              </template>
            </div>
          </template>
        </net-pa-card>
        <div v-else class="list-aza-file">
          <p v-if="!ListFile.length" class="list-aza-file__empty">
            فایلی برای نمایش وجود ندارد
          </p>
          <template v-else>
            <div class="list-aza-file__toolbar">
              <input
                v-model="cardSearch"
                type="search"
                class="form-control list-aza-file__search"
                placeholder=" جستجو"
                aria-label="جستجو در فایل‌ها"
              />
            </div>
            <p v-if="filteredFiles.length === 0" class="list-aza-file__empty">
              اطلاعاتی یافت نشد
            </p>
            <div v-else class="list-aza-file__list">
              <article
                v-for="(item, index) in filteredFiles"
                :key="(item.wwwtblAttachmentId || 'file') + '-' + index"
                class="list-aza-file-card"
              >
                <div class="list-aza-file-card__preview" aria-hidden="true">
                  <i :class="fileIcon(item.filename)"></i>
                </div>
                <div class="list-aza-file-card__body">
                  <div class="list-aza-file-card__header">
                    <strong class="list-aza-file-card__name">{{
                      item.filename
                    }}</strong>
                  </div>
                  <div class="list-aza-file-card__actions">
                    <button
                      type="button"
                      class="list-aza-file-chip list-aza-file-chip--download"
                      @click="Download(item)"
                    >
                      <i class="fas fa-download" aria-hidden="true"></i>
                      دانلود فایل
                    </button>
                  </div>
                </div>
              </article>
            </div>
            <div v-if="pageCount > 1" class="list-aza-file__pager">
              <button
                type="button"
                class="list-aza-file__pager-btn"
                :disabled="ActivePage <= 1"
                @click="prevPage"
              >
                قبلی
              </button>
              <span class="list-aza-file__pager-info">
                صفحه {{ ActivePage }} از {{ pageCount }}
              </span>
              <button
                type="button"
                class="list-aza-file__pager-btn"
                :disabled="ActivePage >= pageCount"
                @click="nextPage"
              >
                بعدی
              </button>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Loading from "../Tools/NetPa/Loading.vue";
import Panel from "../Tools/NetPa/Panel.vue";
import NetPaCard from "../Tools/NetPa/NetPaCard.vue";
export default {
  components: { Panel, Loading, NetPaCard },
  data() {
    return {
      loading: false,
      ListFile: [],
      ActivePage: 1,
      CountData: 0,
      cardSearch: "",
    };
  },
  computed: {
    filteredFiles() {
      const q = (this.cardSearch || "").trim().toLowerCase();
      if (!q) return this.ListFile;
      return this.ListFile.filter((item) => {
        const hay = [item.filename, item.fullName, item.codemeli, item.perNo]
          .filter((v) => v != null && v !== "")
          .join(" ")
          .toLowerCase();
        return hay.includes(q);
      });
    },
    pageCount() {
      return Math.max(1, Math.ceil((this.CountData || 0) / 10));
    },
  },
  watch: {
    ListFile() {
      this.cardSearch = "";
    },
  },
  methods: {
    fileIcon(name) {
      const ext = String(name || "")
        .split(".")
        .pop()
        .toLowerCase();
      if (["jpg", "jpeg", "png", "gif"].includes(ext)) return "fas fa-image";
      if (["zip", "rar"].includes(ext)) return "fas fa-file-archive";
      if (ext === "pdf") return "fas fa-file-pdf";
      return "fas fa-file";
    },
    GetAttachList() {
      this.loading = true;
      var dataAxios = {
        Method: "POST",
        Action: "Attach/GetFile",
        Token: this.$session.get("TokenNetPa"), // NetPa HANDOFF P1-4
        ArryfildValue: {
          tableName: "FileToAdmin",
          Page: this.ActivePage,
          wwwtblAzaId: this.wwwtblAzaId,
        },
      };
      this.$PostData(dataAxios).then((res) => {
        if (res.status == "success") {
          this.loading = false;
          this.CountData = res.result.count;
          this.ListFile = res.result.data;
        }
        if (res.status == "not success") {
          this.loading = false;
          this.ListFile = [];
          this.$mySweetDefaultTost(
            "جستجـــو ناموفق",
            "فایل پیوستی برای درخواست انتخابی یافت نشد",
            "warning",
            2000,
          );
        }
      });
    },
    Download(item) {
      var fileLink = document.createElement("a");
      fileLink.download = item.filename;
      fileLink.href = "data:application/octet-stream;base64," + item.binary;
      document.body.appendChild(fileLink);
      fileLink.target = "_blank";
      fileLink.click();
    },
    Hide(item) {
      let DataAxios = {
        ArryfildValue: "",
        Method: "Post",
        Action: "Attach/HideAttachUser",
        Token: this.$session.get("TokenNetPa") /* NetPa HANDOFF P1-4 */,
      };
      var formdata = new FormData();
      formdata.append("wwwtblAttachmentId", item.wwwtblAttachmentId);
      DataAxios.ArryfildValue = formdata;
      this.$PostFormData(DataAxios).then(() => {
        this.GetAttachList();
      });
    },
    prevPage() {
      if (this.ActivePage <= 1) return;
      this.ActivePage -= 1;
      this.GetAttachList();
    },
    nextPage() {
      if (this.ActivePage >= this.pageCount) return;
      this.ActivePage += 1;
      this.GetAttachList();
    },
  },
  mounted() {
    this.GetAttachList();
  },
  props: {
    ShowHeader: { type: Boolean, default: true },
    IsAdmin: { type: Boolean, default: true },
    wwwtblAzaId: { type: Number, default: null },
  },
};
</script>
<style>
#ListAzaFile .list-aza-file__toolbar {
  display: flex;
  margin: 0 0 0.85rem;
}

#ListAzaFile .list-aza-file__search {
  flex: 1 1 12rem;
  min-width: 0;
  min-height: 40px;
  padding: 0.45rem 0.75rem;
  color: #13243a;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 13px;
  font-weight: 500;
  border: 1px solid #dce1e8;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 1px 3px rgba(42, 63, 84, 0.06);
}

#ListAzaFile .list-aza-file__search:focus {
  border-color: #287db4;
  box-shadow: 0 0 0 3px rgba(5, 184, 200, 0.2);
  outline: none;
}

#ListAzaFile .list-aza-file__empty {
  margin: 0.75rem 0 0;
  padding: 1.5rem 1rem;
  color: #6b7b8e;
  font-size: 13px;
  font-weight: 700;
  text-align: center;
  border: 1px dashed #dbe5eb;
  border-radius: 14px;
  background: #f8fafc;
}

#ListAzaFile .list-aza-file__list {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

#ListAzaFile .list-aza-file-card {
  display: flex;
  align-items: flex-start;
  gap: 0.85rem;
  padding: 0.95rem 1rem 0.9rem;
  border: 1px solid #e8eef2;
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 8px 22px rgba(41, 52, 95, 0.06);
}

#ListAzaFile .list-aza-file-card__preview {
  display: flex;
  flex: 0 0 48px;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  color: #5b6f8a;
  font-size: 18px;
  border: 1px dashed #b7c4d6;
  border-radius: 14px;
  background: #eef2fb;
}

#ListAzaFile .list-aza-file-card__body {
  flex: 1 1 auto;
  min-width: 0;
}

#ListAzaFile .list-aza-file-card__header {
  margin-bottom: 0.45rem;
}

#ListAzaFile .list-aza-file-card__name {
  color: #13243a;
  font-size: 14px;
  font-weight: 800;
  line-height: 1.45;
  overflow-wrap: anywhere;
  word-break: break-word;
}

#ListAzaFile .list-aza-file-card__fields {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

#ListAzaFile .list-aza-file-card__field {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 0.75rem;
}

#ListAzaFile .list-aza-file-card__field span {
  flex-shrink: 0;
  color: #6b7b8e;
  font-size: 12px;
  font-weight: 700;
}

#ListAzaFile .list-aza-file-card__field strong {
  min-width: 0;
  color: #13243a;
  font-size: 13px;
  font-weight: 700;
  text-align: left;
  overflow-wrap: anywhere;
  word-break: break-word;
}

#ListAzaFile .list-aza-file-card__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.45rem;
  margin-top: 0.75rem;
}

#ListAzaFile .list-aza-file-chip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.35rem;
  min-height: 34px;
  padding: 0.3rem 0.7rem;
  border: 1px solid;
  border-radius: 10px;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
}

#ListAzaFile .list-aza-file-chip--download {
  color: #2f7a1f;
  border-color: #b7dfb0;
  background: #eef8ec;
}

#ListAzaFile .list-aza-file-chip--hide {
  color: #b44f46;
  border-color: #f0c9c5;
  background: #fcefed;
}

#ListAzaFile .list-aza-file__pager {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  margin-top: 0.85rem;
}

#ListAzaFile .list-aza-file__pager-btn {
  min-height: 34px;
  padding: 0.3rem 0.85rem;
  color: #29345f;
  border: 1px solid #dbe5eb;
  border-radius: 10px;
  background: #fff;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
}

#ListAzaFile .list-aza-file__pager-btn:disabled {
  opacity: 0.45;
  cursor: default;
}

#ListAzaFile .list-aza-file__pager-info {
  color: #6b7b8e;
  font-size: 12px;
  font-weight: 700;
}

@media (min-width: 768px) {
  #ListAzaFile .list-aza-file__search {
    max-width: 20rem;
  }

  #ListAzaFile .list-aza-file__list {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
    gap: 0.7rem;
  }

  #ListAzaFile .list-aza-file-card {
    align-items: center;
    padding: 0.7rem 0.8rem;
    border-radius: 14px;
  }

  #ListAzaFile .list-aza-file-card__preview {
    flex-basis: 40px;
    width: 40px;
    height: 40px;
    font-size: 15px;
    border-radius: 12px;
  }

  #ListAzaFile .list-aza-file-card__body {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: 0.35rem 0.65rem;
  }

  #ListAzaFile .list-aza-file-card__header {
    flex: 1 1 8rem;
    margin-bottom: 0;
  }

  #ListAzaFile .list-aza-file-card__name {
    font-size: 13px;
  }

  #ListAzaFile .list-aza-file-card__fields {
    flex: 1 1 100%;
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 0.3rem 0.65rem;
  }

  #ListAzaFile .list-aza-file-card__field {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.1rem;
  }

  #ListAzaFile .list-aza-file-card__field strong {
    text-align: right;
  }

  #ListAzaFile .list-aza-file-card__actions {
    flex: 0 0 auto;
    margin-top: 0;
  }

  #ListAzaFile .list-aza-file__pager {
    max-width: 28rem;
  }
}

@media (max-width: 767px) {
  #ListAzaFile .list-aza-file-card__actions .list-aza-file-chip {
    flex: 1 1 7rem;
  }
}
</style>
